export const WHATSAPP_URL = "https://wa.me/message/UIDRIY4XJHIOB1";
export const PHONE_DISPLAY = "06 20 75 22 92";
export const PHONE_TEL = "+33620752292";

export const VIDEO = {
  mp4: "/media/steve-clip.mp4",
  webm: "/media/steve-clip.webm",
  poster: "/media/steve-clip-poster.jpg",
};

export const IMAGES = {
  hero: "https://customer-assets-gfyr7b9c.emergentagent.net/job_2d19216d-a25e-4b4b-a1fe-45373bc2f128/artifacts/gv02cu4s_IMG_3386.jpeg",
  homeTop: "https://customer-assets-39nsmqrw.emergentagent.net/job_wellness-idf-mobile/artifacts/omiyr1ir_IMG_3386.jpeg",
  therapist: "https://customer-assets-gfyr7b9c.emergentagent.net/job_2d19216d-a25e-4b4b-a1fe-45373bc2f128/artifacts/9c6dm446_IMG_1798.jpeg",
  room: "https://images.unsplash.com/photo-1651065213855-e6094f99ee65?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  candles: "https://images.unsplash.com/photo-1706795033849-7ca391f007c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  oil: "https://images.unsplash.com/photo-1662467191034-9cc663f1de92?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  stones: "https://images.unsplash.com/photo-1696841212541-449ca29397cc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  leaf: "https://images.unsplash.com/photo-1658934475116-990b909c3038?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  after1: "https://customer-assets-39nsmqrw.emergentagent.net/job_wellness-idf-mobile/artifacts/cr8tdgwt_IMG_1065.jpeg",
  after2: "https://customer-assets-39nsmqrw.emergentagent.net/job_wellness-idf-mobile/artifacts/o0dm99wl_IMG_1058.jpeg",
  after3: "https://customer-assets-39nsmqrw.emergentagent.net/job_wellness-idf-mobile/artifacts/7rd17z9v_IMG_1059.jpeg",
  after4: "https://customer-assets-39nsmqrw.emergentagent.net/job_wellness-idf-mobile/artifacts/aw75oqb6_IMG_1050.webp",
  mini1: "https://customer-assets-39nsmqrw.emergentagent.net/job_wellness-idf-mobile/artifacts/lp5ravey_IMG_3340.jpeg",
  mini2: "https://customer-assets-39nsmqrw.emergentagent.net/job_wellness-idf-mobile/artifacts/zsu6bmgp_IMG_3397.jpeg",
  mini3: "https://customer-assets-39nsmqrw.emergentagent.net/job_wellness-idf-mobile/artifacts/vrqheqtr_IMG_3401.jpeg",
};

export const translations = {
  fr: {
    nav: { services: "Soins", experience: "Expérience", gallery: "Résultats", reviews: "Avis", pricing: "Tarifs", book: "Réserver" },
    hero: {
      overline: "Massage à domicile · Paris & Île-de-France",
      title: ["Massage", "à votre", "domicile."],
      subtitle:
        "Une parenthèse de détente professionnelle, exclusivement pour femmes. Je me déplace avec ma table de massage et mes huiles, à toute heure, partout en Île-de-France.",
      cta: "Réserver sur WhatsApp",
      scroll: "Découvrir",
    },
    marquee: "STEVE MASSAGE · PARIS · DÉTENTE À DOMICILE · SOINS SUR-MESURE · ÎLE-DE-FRANCE · 24H/24 · ",
    intro: {
      overline: "En séance",
      title: "Un savoir-faire, des mains expertes.",
      text: "Chaque geste est pensé pour dénouer les tensions et vous emmener vers un lâcher-prise total. Table professionnelle, huiles chaudes et ambiance feutrée — tout est installé chez vous en quelques minutes.",
      videoTag: "Massage relaxant · en direct",
    },
    priceMenu: { label: "Voir les tarifs", title: "Tarifs", cta: "Réserver" },
    services: {
      overline: "La carte des soins",
      title: "Dix rituels, une seule promesse : le relâchement total.",
      note: "Chaque soin est adapté à vos besoins et à votre corps. Tous les massages sont réalisés dans le plus grand respect de votre intimité.",
      items: [
        { n: "01", name: "Massage suédois", desc: "Le plus populaire. Relaxe les muscles et améliore la circulation. Idéal pour une première expérience." },
        { n: "02", name: "Massage californien", desc: "Mouvements longs, fluides et enveloppants. Très relaxant et anti-stress." },
        { n: "03", name: "Massage thaïlandais", desc: "Combinaison de pressions, d’étirements et de mobilisations. Se pratique habillé, sans huile." },
        { n: "04", name: "Massage aux pierres chaudes", desc: "Pierres volcaniques chauffées pour une détente musculaire profonde." },
        { n: "05", name: "Deep Tissue", desc: "Pressions plus intenses. Recommandé pour les tensions chroniques et les sportives." },
        { n: "06", name: "Drainage lymphatique", desc: "Massage doux qui favorise la circulation de la lymphe et réduit la sensation de jambes lourdes." },
        { n: "07", name: "Massage ayurvédique", desc: "Massage traditionnel indien à l’huile chaude. Favorise la relaxation et le rééquilibrage du corps." },
        { n: "08", name: "Shiatsu", desc: "Technique japonaise par pressions des doigts, inspirée de la médecine traditionnelle asiatique." },
        { n: "09", name: "Réflexologie plantaire", desc: "Massage des pieds ciblant les zones réflexes pour la détente et le bien-être général." },
        { n: "10", name: "Massage sportif", desc: "Adapté avant ou après l’effort. Aide à prévenir les blessures et accélère la récupération." },
      ],
    },
    manifesto: {
      overline: "L’expérience",
      title: "Un vrai spa, sans quitter votre chez-vous.",
      chapters: [
        { n: "01", title: "Disponible 24h/24", text: "Je me déplace à toute heure du jour comme de la nuit, selon votre rythme." },
        { n: "02", title: "Toute l’Île-de-France", text: "Basé à Paris, je me déplace dans l’ensemble de la région, à votre domicile ou votre hôtel." },
        { n: "03", title: "Matériel professionnel fourni", text: "J’arrive avec ma table de massage et mes huiles. Vous n’avez rien à préparer." },
        { n: "04", title: "Exclusivement pour femmes", text: "Un service pensé pour votre confort, votre sécurité et votre sérénité." },
        { n: "05", title: "Réservation 2h à l’avance", text: "Contactez-moi au moins deux heures avant le soin souhaité pour organiser le déplacement." },
      ],
    },
    intimacy: {
      overline: "Confort & intimité",
      title: "Votre bien-être, dans le plus grand respect.",
      text: "Le massage se pratique dans une ambiance tamisée et sereine. Pour un relâchement optimal, vous pouvez être entièrement dénudée si vous le souhaitez — vous restez toujours couverte par un drap, à votre convenance. Votre confort et votre intimité sont ma priorité absolue.",
    },
    gallery: {
      overline: "Résultats",
      title: "Après la séance, la détente se lit sur les visages.",
      note: "Instantanés réels de clientes juste après leur soin à domicile.",
      items: [
        { location: "Paris", caption: "Après 1h30 de massage relaxant" },
        { location: "Montreuil", caption: "Après 1h de massage · cliente satisfaite" },
        { location: "Paris", caption: "2h de massage personnalisé · cliente satisfaite" },
      ],
    },
    reviews: {
      overline: "Elles témoignent",
      title: "Ce que disent mes clientes.",
      items: [
        { name: "Camille L.", city: "Paris 11e", text: "Un moment hors du temps. Steve est arrivé avec tout le nécessaire, table et huiles. Massage suédois parfait, je me suis endormie. Je recommande à 200%." },
        { name: "Sofia M.", city: "Boulogne-Billancourt", text: "Très professionnel et rassurant. J'appréhendais un massage à domicile mais tout était impeccable et respectueux. Les 2h sont passées trop vite !" },
        { name: "Inès B.", city: "Montreuil", text: "Enfin un masseur qui se déplace tard le soir. Deep tissue au top pour mes tensions de sportive. Ponctuel, discret, des mains en or." },
        { name: "Léa D.", city: "Neuilly-sur-Seine", text: "Le massage aux pierres chaudes est une pure merveille. Ambiance détente immédiate chez moi. Je réserve déjà la prochaine séance." },
      ],
    },
    pricing: {
      overline: "Tarifs",
      title: "Simple et transparent.",
      plans: [
        { duration: "1 h 30", price: "100€", desc: "Le format idéal pour un relâchement complet." },
        { duration: "2 h 00", price: "140€", desc: "L’expérience prolongée, pour une détente absolue." },
      ],
      cta: "Réserver mon soin",
    },
    footer: {
      title: "Offrez-vous une parenthèse.",
      text: "Réservez votre massage à domicile dès maintenant, où que vous soyez en Île-de-France.",
      cta: "Écrire sur WhatsApp",
      callCta: "Appeler",
      phoneLabel: "Téléphone",
      location: "Paris · Île-de-France · 24h/24",
      rights: "Tous droits réservés.",
    },
    whatsappLabel: "Réserver sur WhatsApp",
  },
  en: {
    nav: { services: "Treatments", experience: "Experience", gallery: "Results", reviews: "Reviews", pricing: "Pricing", book: "Book" },
    hero: {
      overline: "In-home massage · Paris & Île-de-France",
      title: ["Massage", "at your", "home."],
      subtitle:
        "A professional moment of relaxation, exclusively for women. I come to you with my massage table and oils, at any hour, anywhere in the Île-de-France region.",
      cta: "Book on WhatsApp",
      scroll: "Discover",
    },
    marquee: "STEVE MASSAGE · PARIS · IN-HOME RELAXATION · BESPOKE TREATMENTS · ÎLE-DE-FRANCE · 24/7 · ",
    intro: {
      overline: "In session",
      title: "True craft, expert hands.",
      text: "Every movement is designed to release tension and guide you into total letting-go. Professional table, warm oils and a soft atmosphere — everything is set up at your place in just a few minutes.",
      videoTag: "Relaxing massage · live",
    },
    priceMenu: { label: "View pricing", title: "Pricing", cta: "Book" },
    services: {
      overline: "The treatment menu",
      title: "Ten rituals, one promise: total release.",
      note: "Every treatment is tailored to your body and your needs. All massages are performed with the utmost respect for your privacy.",
      items: [
        { n: "01", name: "Swedish massage", desc: "The most popular. Relaxes muscles and improves circulation. Perfect for a first experience." },
        { n: "02", name: "Californian massage", desc: "Long, flowing and enveloping movements. Deeply relaxing and anti-stress." },
        { n: "03", name: "Thai massage", desc: "A blend of pressure, stretching and mobilisation. Usually performed clothed, without oil." },
        { n: "04", name: "Hot stone massage", desc: "Heated volcanic stones for deep muscular relaxation." },
        { n: "05", name: "Deep Tissue", desc: "More intense pressure. Recommended for chronic tension and athletes." },
        { n: "06", name: "Lymphatic drainage", desc: "A gentle massage boosting lymph flow and easing the feeling of heavy legs." },
        { n: "07", name: "Ayurvedic massage", desc: "Traditional Indian warm-oil massage. Promotes relaxation and rebalances the body." },
        { n: "08", name: "Shiatsu", desc: "A Japanese finger-pressure technique inspired by traditional Asian medicine." },
        { n: "09", name: "Foot reflexology", desc: "A foot massage targeting reflex zones for relaxation and overall well-being." },
        { n: "10", name: "Sports massage", desc: "Ideal before or after exercise. Helps prevent injury and speed up recovery." },
      ],
    },
    manifesto: {
      overline: "The experience",
      title: "A real spa, without leaving home.",
      chapters: [
        { n: "01", title: "Available 24/7", text: "I travel to you at any hour, day or night, to fit your schedule." },
        { n: "02", title: "All of Île-de-France", text: "Based in Paris, I travel across the whole region, to your home or your hotel." },
        { n: "03", title: "Professional equipment provided", text: "I arrive with my massage table and oils. There is nothing for you to prepare." },
        { n: "04", title: "Exclusively for women", text: "A service designed for your comfort, safety and peace of mind." },
        { n: "05", title: "Book 2 hours ahead", text: "Please contact me at least two hours before your desired treatment so I can arrange travel." },
      ],
    },
    intimacy: {
      overline: "Comfort & privacy",
      title: "Your well-being, treated with total respect.",
      text: "The massage takes place in a soft, serene atmosphere. For optimal release, you may be fully undressed if you wish — you always remain covered by a sheet, as you prefer. Your comfort and privacy are my absolute priority.",
    },
    gallery: {
      overline: "Results",
      title: "After the session, relaxation speaks for itself.",
      note: "Real snapshots of clients right after their in-home treatment.",
      items: [
        { location: "Paris", caption: "After 1h30 of relaxing massage" },
        { location: "Montreuil", caption: "After 1h massage · happy client" },
        { location: "Paris", caption: "2h bespoke massage · happy client" },
      ],
    },
    reviews: {
      overline: "They loved it",
      title: "What my clients say.",
      items: [
        { name: "Camille L.", city: "Paris 11e", text: "A moment out of time. Steve arrived with everything — table and oils. Perfect Swedish massage, I fell asleep. I recommend 200%." },
        { name: "Sofia M.", city: "Boulogne-Billancourt", text: "Very professional and reassuring. I was nervous about an at-home massage but everything was impeccable and respectful. The 2 hours flew by!" },
        { name: "Inès B.", city: "Montreuil", text: "Finally a therapist who travels late in the evening. Great deep tissue for my athletic tension. Punctual, discreet, golden hands." },
        { name: "Léa D.", city: "Neuilly-sur-Seine", text: "The hot stone massage is pure bliss. Instant relaxation right at home. I'm already booking the next session." },
      ],
    },
    pricing: {
      overline: "Pricing",
      title: "Simple and transparent.",
      plans: [
        { duration: "1 h 30", price: "€100", desc: "The ideal format for a complete release." },
        { duration: "2 h 00", price: "€140", desc: "The extended experience, for absolute relaxation." },
      ],
      cta: "Book my treatment",
    },
    footer: {
      title: "Give yourself a moment.",
      text: "Book your in-home massage now, wherever you are in the Île-de-France region.",
      cta: "Message on WhatsApp",
      callCta: "Call",
      phoneLabel: "Phone",
      location: "Paris · Île-de-France · 24/7",
      rights: "All rights reserved.",
    },
    whatsappLabel: "Book on WhatsApp",
  },
};
